module.exports = __webpack_public_path__ + "static/media/10-5.bf00360a.mp3";